
import React, { useEffect, useState } from 'react';
import { Box, Container, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import FoundationIcon from '@mui/icons-material/Foundation';
import PopupDialog from "../../components/common/PopupDialog";
import ContactForm from "../../components/contactForm/ContactForm";

export default function Construction() {
    const [openQuote, setOpenQuote] = useState(false);
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{ py: 8, bgcolor: '#f9f9f9' }}>
            <Container>
                <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#1f2937' }}>
                    Construction Services
                </Typography>
                <Typography variant="h6" color="text.secondary" paragraph>
                    Quality construction with premium materials and experienced craftsmanship.
                </Typography>
                
                <Box sx={{ my: 4, p: 4, bgcolor: 'white', borderRadius: 2, boxShadow: 1 }}>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#9d722d' }}>
                        What We Build
                    </Typography>
                    <List>
                        {[
                            "Residential Homes & Villas",
                            "Commercial Complexes",
                            "Apartment Buildings",
                            "Renovation & Remodeling",
                            "Structural Repairs",
                            "Turnkey Projects"
                        ].map((item, index) => (
                            <ListItem key={index}>
                                <ListItemIcon>
                                    <FoundationIcon sx={{ color: '#9d722d' }} />
                                </ListItemIcon>
                                <ListItemText primary={item} />
                            </ListItem>
                        ))}
                    </List>
                </Box>

                <Button 
                    variant="contained" 
                    size="large"
                    sx={{ bgcolor: '#1f2937', '&:hover': { bgcolor: '#000' } }}
                    onClick={() => setOpenQuote(true)}
                >
                    Start Construction
                </Button>
            </Container>
            
            <PopupDialog open={openQuote} onClose={() => setOpenQuote(false)} title="Start Project">
                <ContactForm 
                    title="Build With Us" 
                    subtitle="Share your project details" 
                    buttonText="Get Quote"
                    onSubmit={() => setOpenQuote(false)}
                />
            </PopupDialog>
        </Box>
    );
}
